import { fetchDamageWaiverConfig as fetchDamageWaiverConfigApi } from '../util/api';
import { DEFAULT_DAMAGE_WAIVER_CONFIG, getDamageWaiverFeeAmount } from '../util/damageWaiver';

const FETCH_REQUEST = 'app/damageWaiver/FETCH_REQUEST';
const FETCH_SUCCESS = 'app/damageWaiver/FETCH_SUCCESS';
const FETCH_ERROR = 'app/damageWaiver/FETCH_ERROR';

const initialState = {
  config: DEFAULT_DAMAGE_WAIVER_CONFIG,
  fetchInProgress: false,
  loaded: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_SUCCESS:
      return {
        ...state,
        config: action.payload,
        fetchInProgress: false,
        loaded: true,
      };
    case FETCH_ERROR:
      return {
        ...state,
        config: DEFAULT_DAMAGE_WAIVER_CONFIG,
        fetchInProgress: false,
        loaded: true,
        fetchError: action.payload,
      };
    default:
      return state;
  }
}

const normalizePublicConfig = value => {
  const config = value || {};
  const enabled =
    config.enabled === true && Number.isSafeInteger(config.feeAmount) && config.feeAmount > 0;

  return {
    enabled,
    feeAmount: enabled ? config.feeAmount : null,
    displayLabel:
      typeof config.displayLabel === 'string' && config.displayLabel.trim()
        ? config.displayLabel.trim()
        : DEFAULT_DAMAGE_WAIVER_CONFIG.displayLabel,
    description: typeof config.description === 'string' ? config.description.trim() : '',
  };
};

export const loadDamageWaiverConfig = () => async (dispatch, getState) => {
  const state = getState().damageWaiver || initialState;
  if (state.loaded || state.fetchInProgress) {
    return state.config;
  }

  dispatch({ type: FETCH_REQUEST });
  try {
    const response = await fetchDamageWaiverConfigApi();
    const config = normalizePublicConfig(response?.damageWaiver);
    dispatch({ type: FETCH_SUCCESS, payload: config });
    return config;
  } catch (error) {
    dispatch({ type: FETCH_ERROR, payload: error });
    return DEFAULT_DAMAGE_WAIVER_CONFIG;
  }
};

export const damageWaiverConfigSelector = state =>
  state.damageWaiver?.config || DEFAULT_DAMAGE_WAIVER_CONFIG;

export { DEFAULT_DAMAGE_WAIVER_CONFIG, getDamageWaiverFeeAmount };
